import React from 'react';
import { Sidebar, MobileBottomNav } from './Sidebar';
import { Topbar } from './Topbar';
import { useAuth } from '@/lib/auth';

export function AppShell({ children }) {
  const { user } = useAuth();
  if (!user) return children;
  return (
    <div className="min-h-dvh flex bg-background">
      <Sidebar role={user.role} />
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar />
        <main className="flex-1 px-3 sm:px-6 lg:px-8 py-4 sm:py-6 pb-24 md:pb-6 max-w-[1440px] w-full mx-auto">
          {children}
        </main>
        {user.role === 'tenant' && <MobileBottomNav role="tenant" />}
      </div>
    </div>
  );
}
